import { StoreState } from "./index";

export const getScreenName = (state: StoreState) => state.screenName;
export const getData = (state: StoreState) => state.config.data;
export const getDisplaySize = (state: StoreState) => state.displaySize;
export const getIsOverlay = (state: StoreState) => state.isOverlay;
export const getWidgetId = (state: StoreState) => state.widgetId;
export const getWidgetConfig = (state: StoreState) => state.config;
export const getWidgetConfigId = (state: StoreState) => state.widgetConfigId;
export const getWidgetFormErrors = (state: StoreState) => state.formError;
